import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Home from "./Home";
import Check from "./Pages/Check";
import Form from "./Pages/Form";
import Info from "./Pages/Info";
import News from "./Pages/News";
import NewsDetail from "./Pages/NewsDetail";
import Savings from "./Pages/Savings";
import Locations from "./Pages/Locations";
import SavingsDetail from "./Pages/SavingsDetail";
import Live from "./Pages/Live";
import Download from "./Pages/Download";

const router = createBrowserRouter(
  [
    // { path: "/", element: <Home /> },
    { path: "/", element: <Check /> },
    { path: "/download", element: <Download /> },
    { path: "/form", element: <Form /> },
    { path: "/info", element: <Info /> },
    { path: "/news", element: <News /> },
    { path: "/savings", element: <Savings /> },
    { path: "/locations", element: <Locations /> },
    { path: "/news/:id", element: <NewsDetail /> },
    { path: "/live", element: <Live /> },
    { path: "/savings/:id", element: <SavingsDetail /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

function AppRouting() {
  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
}

export default AppRouting;
